import { pitchClassNames } from "../constants";

const pitchAsBits = () => [
// C  C# D  D# E   F   F#  G    G#   A    A#    B
   1, 2, 4, 8, 16, 32, 64, 128, 256, 512, 1024, 2048
];
const blackKeyMask = () => 2 | 8 | 64 | 256 | 1024;

export const isValidKeyboardIndex = (keyboardIndex: number) => {
  // 0 = A0, 87 = C8
  return keyboardIndex >= 0 && keyboardIndex <= 87;
}

const throwIfInvalidKeyboardIndex = (keyboardIndex: number) => {
  if (!isValidKeyboardIndex(keyboardIndex)) {
    throw new Error('Keyboard index out of range');
  }
}

export const pitchClass = (keyboardIndex: number) => {
  throwIfInvalidKeyboardIndex(keyboardIndex);

  return pitchClassNames()[(keyboardIndex + 9) % 12];
};

export const register = (keyboardIndex: number) => {
  throwIfInvalidKeyboardIndex(keyboardIndex);

  return Math.floor((keyboardIndex + 9) / 12);
};

export const isBlackKey = (keyboardIndex: number) => {
  throwIfInvalidKeyboardIndex(keyboardIndex);

  const keyBit = pitchAsBits()[(keyboardIndex + 9) % 12];

  return Boolean(keyBit & blackKeyMask());
};

export const scientificPitchNotation = (keyboardIndex: number) => {
  throwIfInvalidKeyboardIndex(keyboardIndex);

  return `${pitchClass(keyboardIndex)}${isBlackKey(keyboardIndex) ? '#' : ''}${register(keyboardIndex)}`;
}
